import instance from './instance';
import { Profession } from '../models';

export interface GetProfessionParams
  extends Partial<Pick<Profession, 'parentNumber'>> {}

export function getProfessionList(
  params: GetProfessionParams
): Promise<Profession[]> {
  return instance()
    .get('/profession/getAll', {
      params,
    })
    .then((response) => response.data);
}

export function getParentProfessionList(): Promise<Profession[]> {
  return instance()
    .get('/profession/getParent')
    .then((response) => response.data);
}
